"use client"

import { Button } from "@/components/ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { PauseCircle, PlayCircle } from "lucide-react"

interface PauseControlProps {
  onPause: (minutes: number) => Promise<void>
  isPaused: boolean
  onResume: () => Promise<void>
  translations?: (key: string) => string
}

export function PauseControl({ onPause, isPaused, onResume, translations }: PauseControlProps) {
  // Translation helper function
  const t = (key: string) => {
    if (!translations) return key
    return translations(key)
  }

  if (isPaused) {
    return (
      <Button variant="outline" size="sm" onClick={onResume}>
        <PlayCircle className="h-4 w-4 mr-2" />
        {t('functions.resume_automation')}
      </Button>
    )
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <PauseCircle className="h-4 w-4 mr-2" />
          {t('functions.pause_automation')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem onClick={() => onPause(30)}>{t('functions.pause_30_minutes')}</DropdownMenuItem>
        <DropdownMenuItem onClick={() => onPause(60)}>{t('functions.pause_1_hour')}</DropdownMenuItem>
        <DropdownMenuItem onClick={() => onPause(120)}>{t('functions.pause_2_hours')}</DropdownMenuItem>
        <DropdownMenuItem onClick={() => onPause(240)}>{t('functions.pause_4_hours')}</DropdownMenuItem>
        <DropdownMenuItem onClick={() => onPause(480)}>{t('functions.pause_8_hours')}</DropdownMenuItem>
        <DropdownMenuItem onClick={() => onPause(Number.POSITIVE_INFINITY)}>{t('functions.pause_indefinitely')}</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
